/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/MenuPermissionResponse'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./MenuPermissionResponse'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.MenuPermissionResponse = factory(root.GisServerApis.ApiClient, root.GisServerApis.MenuPermissionResponse);
  }
}(this, function(ApiClient, MenuPermissionResponse) {
  'use strict';




  /**
   * The MenuPermissionResponse model module.
   * @module model/MenuPermissionResponse
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>MenuPermissionResponse</code>.
   * A response of menu permission.
   * @alias module:model/MenuPermissionResponse
   * @class
   */
  var exports = function() {
    var _this = this;







  };

  /**
   * Constructs a <code>MenuPermissionResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MenuPermissionResponse} obj Optional instance to populate.
   * @return {module:model/MenuPermissionResponse} The populated <code>MenuPermissionResponse</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('text')) {
        obj['text'] = ApiClient.convertToType(data['text'], 'String');
      }
      if (data.hasOwnProperty('url')) {
        obj['url'] = ApiClient.convertToType(data['url'], 'String');
      }
      if (data.hasOwnProperty('target')) {
        obj['target'] = ApiClient.convertToType(data['target'], 'String');
      }
      if (data.hasOwnProperty('class')) {
        obj['class'] = ApiClient.convertToType(data['class'], 'String');
      }
      if (data.hasOwnProperty('children')) {
        obj['children'] = ApiClient.convertToType(data['children'], [MenuPermissionResponse]);
      }
    }
    return obj;
  }

  /**
   * The ID of the menu.
   * @member {String} id
   */
  exports.prototype['id'] = undefined;
  /**
   * The text of the menu. It will list on the left of the Admin UI.
   * @member {String} text
   */
  exports.prototype['text'] = undefined;
  /**
   * The redirecting URL when clicking the menu.
   * @member {String} url
   */
  exports.prototype['url'] = undefined;
  /**
   * A value indicates how to open the URL.
   * @member {String} target
   */
  exports.prototype['target'] = undefined;
  /**
   * The CSS class for the menu.
   * @member {String} class
   */
  exports.prototype['class'] = undefined;
  /**
   * The children nodes of the menu.
   * @member {Array.<module:model/MenuPermissionResponse>} children
   */
  exports.prototype['children'] = undefined;



  return exports;
}));



